import { EntityModel } from '@/interfaces'
import {
  ALL_RATIO_CONFIGS_QUERY,
  CREATE_RATIO_CONFIG_MUTATION,
  DELETE_RATIO_CONFIG_MUTATION,
  FORCE_DELETE_RATIO_CONFIG_MUTATION,
  SINGLE_RATIO_CONFIG_QUERY,
  UPDATE_RATIO_CONFIG_MUTATION,
} from './graphql'
import travelDocumentationServicesEntity from '@/entities/travelDocumentationServices/entity'
import ratioBargainConfigEntity from '@/entities/ratioBargainConfig/entity'
import ratioEsimConfigEntity from '@/entities/ratioEsimConfig/entity'

const ratioConfigModel: EntityModel = {
  name: 'ratioConfig',
  namePlural: 'ratioConfigs',
  uniqueName: 'ratioConfig',
  uniqueNamePlural: 'ratioConfigs',
  path: 'config/ratio/ratio_config',
  baseUrl: '/config/ratio',
  translationPrefix: 'entities:ratioConfig.',
  getDisplayName: (values: any) => {
    return 'Ratio Config'
  },
  gql: {
    getAll: ALL_RATIO_CONFIGS_QUERY,
    getSingle: SINGLE_RATIO_CONFIG_QUERY,
    create: CREATE_RATIO_CONFIG_MUTATION,
    update: UPDATE_RATIO_CONFIG_MUTATION,
    delete: DELETE_RATIO_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_RATIO_CONFIG_MUTATION,
  },
  attributes: {
    travelDocumentationServices: {
      name: 'travelDocumentationServices',
      label: 'entities:ratioConfig.attributes.travelDocumentationServices.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelDocumentationServicesEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    bargainConfig: {
      name: 'bargainConfig',
      label: 'entities:ratioConfig.attributes.bargainConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioBargainConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    esimConfig: {
      name: 'esimConfig',
      label: 'entities:ratioConfig.attributes.esimConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioEsimConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioConfigModel
